import { render } from "./CollectionHome.vue?vue&type=template&id=49490baa&scoped=true"
import script from "./CollectionHome.vue?vue&type=script&lang=js"
export * from "./CollectionHome.vue?vue&type=script&lang=js"

import "./CollectionHome.vue?vue&type=style&index=0&id=49490baa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49490baa"]])

export default __exports__